/**
 * N1 installation loudspeaker — everything the product page states as fact.
 *
 * Source: Dan's "N1 website handoff" v1.0 (19 Sep 2026). The N1 is quoted, not
 * sold through the cart, so these prices are deliberately NOT in prices.js:
 * the payment service must never be able to charge for an N1.
 */

/* Every figure on the N1 page comes from the handoff, and the copy is the
   handoff's own wording, shortened. Only headings and form labels are ours.

   Per speaker, in euro, excluding VAT. */
export const N1_VARIANTS = [
  {
    id: "N1-8",
    woofer: '8"',
    rms: 300,
    typicalUse: "Cafés, small bars, retail",
    price: { active: 599, passive: 419 },
  },
  {
    id: "N1-12",
    woofer: '12"',
    rms: 900,
    typicalUse: "Restaurants, bars, venues",
    price: { active: 1659, passive: 1161 },
  },
  {
    id: "N1-15",
    woofer: '15"',
    rms: 2000,
    typicalUse: "Large venues, cinema halls",
    price: { active: 2500, passive: 1750 },
  },
];

export const N1_CONFIGURATIONS = [
  {
    id: "active",
    label: "Active",
    hint: "Built-in Hypex amp",
  },
  {
    id: "passive",
    label: "Passive",
    hint: "Your own amplifier",
  },
];

export const N1_MOUNTING = [
  "Chain / flown",
  "Floor or table stand",
  "Wall or ceiling bracket",
  "Custom mount",
  "Not sure yet",
];

export const N1_FROM_PRICE = Math.min(
  ...N1_VARIANTS.map((variant) => variant.price.passive),
);

const euro = new Intl.NumberFormat("en-IE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

export function formatEuro(amount) {
  return euro.format(amount);
}

export function n1Variant(id) {
  return N1_VARIANTS.find((variant) => variant.id === id) || N1_VARIANTS[0];
}
